import {
	Checkbox,
	FormControl,
	Grid,
	TableCell,
	TableRow,
	TextField
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import IconButton from "@material-ui/core/IconButton";
import TrashCan24 from "@carbon/icons-react/lib/trash-can/24";
import classnames from "classnames";
import ImportError from "../../common/components/ImportError";
import PlayerFormat from "../../../util/player-format";
import commonStyles from "../../common/styles/Common.styles";

const PlayerImportRow = ({
	player,
	years,
	teamPlayers,
	onChange = () => {},
	onPlayerDelete = () => {}
}) => {
	const commonClasses = commonStyles();

	const {
		importIndex,
		firstName,
		lastName,
		year,
		playerMatch,
		number,
		nationalRanking,
		regionalRanking,
		conferenceRanking,
		starter,
		single,
		doubles,
		errors
	} = player;

	const getFieldErrors = (field) => {
		return player.errors?.[field]?.join(", ") || "";
	};

	return (
		<TableRow
			key={importIndex}
			className={classnames({ [commonClasses.error]: Object.keys(errors).length })}
		>
			<TableCell>
				<Grid container spacing={1}>
					<Grid item md={6}>
						<TextField
							value={firstName}
							error={!!getFieldErrors("firstName")}
							helperText={getFieldErrors("firstName")}
							inputProps={{ "aria-label": "First Name" }}
							onChange={(event) =>
								onChange(Object.assign(player, { firstName: event.target.value }))
							}
						/>
					</Grid>
					<Grid item md={6}>
						<TextField
							value={lastName}
							error={!!getFieldErrors("lastName")}
							helperText={getFieldErrors("lastName")}
							inputProps={{ "aria-label": "Last Name" }}
							onChange={(event) =>
								onChange(Object.assign(player, { lastName: event.target.value }))
							}
						/>
					</Grid>
				</Grid>
			</TableCell>
			<TableCell>
				<Autocomplete
					id="years"
					options={years}
					getOptionLabel={(option) => `${option.name} (${option.code})`}
					renderInput={(params) => <TextField {...params} variant="outlined" />}
					onChange={(event, value) => {
						onChange(Object.assign(player, { year: value }));
					}}
					getOptionSelected={(option, value) => {
						return option.code === value.code;
					}}
					defaultValue={year}
				/>
			</TableCell>
			<TableCell>
				<TextField
					value={number}
					error={!!getFieldErrors("number")}
					helperText={getFieldErrors("number")}
					inputProps={{ "aria-label": "Number" }}
					onChange={(event) =>
						onChange(Object.assign(player, { number: event.target.value }))
					}
				/>
			</TableCell>
			<TableCell>
				<FormControl>{nationalRanking}</FormControl>
				<ImportError errors={errors} field="nationalRanking" />
			</TableCell>
			<TableCell>
				<FormControl>{regionalRanking}</FormControl>
				<ImportError errors={errors} field="regionalRanking" />
			</TableCell>
			<TableCell>
				<FormControl>{conferenceRanking}</FormControl>
				<ImportError errors={errors} field="conferenceRanking" />
			</TableCell>
			<TableCell>
				<Checkbox
					checked={starter}
					onChange={() => onChange(Object.assign(player, { starter: !starter }))}
				/>
			</TableCell>
			<TableCell>
				<Checkbox
					checked={single}
					onChange={() => onChange(Object.assign(player, { single: !single }))}
				/>
			</TableCell>
			<TableCell>
				<Checkbox
					checked={doubles}
					onChange={() => onChange(Object.assign(player, { doubles: !doubles }))}
				/>
			</TableCell>
			<TableCell>
				<Autocomplete
					options={teamPlayers}
					getOptionLabel={PlayerFormat.getFullName}
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							error={!!getFieldErrors("playerMatch")}
							helperText={getFieldErrors("playerMatch")}
							placeholder="New Player"
						/>
					)}
					onChange={(event, value) => {
						onChange(Object.assign(player, { playerMatch: value }));
					}}
					getOptionSelected={(option, value) => {
						return option.uniform === value.uniform;
					}}
					value={playerMatch}
				/>
			</TableCell>
			<TableCell>
				<IconButton
					aria-label="Delete player"
					onClick={() => onPlayerDelete(player)}
				>
					<TrashCan24 />
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default PlayerImportRow;
